import React from 'react';
import { DialogModal, ModalContainer, ModalHeader } from 'components';
import { Analytics } from 'packages';
import { useTranslator } from 'static/script/app/lang';

const trackBankIdModal = label => {
    Analytics.trackEvent({
        category: 'User Profile',
        action: 'BankID Test',
        label: label
    });
};

const ProfileMenuBankIdModal = ({
    onVerifyWithBankId,
    onCloseAction,
    onDismissAction
}) => {
    const { t } = useTranslator();
    return (
        <DialogModal onDismiss={onCloseAction} mobileFullscreen={false}>
            <ModalContainer
                className="justify-content-sm-start"
                style={{ maxWidth: '40rem', height: 'initial' }}>
                <ModalHeader
                    className="bg-palette-grey-6 border-0"
                    onClose={onCloseAction}>
                    {t('verify_AlertModalHeader')}
                </ModalHeader>
                <div className="pt-3 px-5" id="tr-modal-body">
                    <p className="text-center">{t('verify_AlertModalInfo')}</p>
                    <div
                        className="d-flex justify-content-center my-4"
                        style={{ minHeight: '160px' }}>
                        <img
                            src="/static/images/bankid/bankid.svg"
                            className="payments-settings-bankid w-50 mb-1"
                        />
                    </div>
                    <div className="mt-4">
                        <button
                            className="btn btn-primary btn-fluid"
                            onClick={onVerifyWithBankId}>
                            {t('verify_AlertModalAgreement')}
                        </button>
                        <button
                            className="btn btn-outline-primary btn-fluid mt-4"
                            onClick={onCloseAction}>
                            {t('verify_AlertModalCancel')}
                        </button>
                    </div>
                    <p className="text-center my-4">
                        <button
                            className="btn btn-link text-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                onDismissAction();
                                trackBankIdModal(
                                    'User rejected - Not available'
                                );
                            }}>
                            {t('verify_AlertModalNoId')}
                        </button>
                    </p>
                </div>
            </ModalContainer>
        </DialogModal>
    );
};
export default ProfileMenuBankIdModal;
